export type ErrorType = {
  message: string,
  status: number,
};

export const getRequestParams = (method: string, payload: any = null) => {
  const body = payload ? { body: JSON.stringify(payload) } : {};
  return{ 
    method: method.toUpperCase(),
    headers: { 'Content-Type': 'application/json' },
    ...body
  };
}

export const request = async (url: string, requestOptions = {}) => {
  const result = { success: null, error: null };
  const response = await fetch(url, requestOptions)
    .then(async result => {
      const json = await result.json()
      return { ...json, status: result.status };
    })
    .then(response => response.data ? { ...result, success: response } : { ...result, error: response,  })
    .catch(err =>  ({ ...result, error: err.response || err }));
  return response;
}
